var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"o-header",style:(_vm.getStyle())})
}
var staticRenderFns = []

export { render, staticRenderFns }